module.exports = __webpack_public_path__ + "bf1cb07720c49a36444d978c4b558d3d.svg";